import { Button, ButtonProps } from '@chakra-ui/react';
import IconAddCircle from 'assets/icons/icon-add-circle.svg?react';
import { Link, LinkProps } from 'react-router-dom';

type Props = ButtonProps & Omit<LinkProps, 'to'> & {
  title: string,
  to?: string
};

export default function ButtonCreateNew({ title, to, ...props }: Props) { 
  const buttonProps = {...props, ...(to && {to, as: Link}) }
  return (
    <Button 
      variant="primary"
      rightIcon={<IconAddCircle />}
      as={Link}
      to={to}
      {...buttonProps}
    >
      {title}
    </Button>
  )
}
